const errorMessages = new Map<string, string>([
  ['Unauthorized', 'Error por acceso incorrecto o fallo de contraseña'],
  ['NotEnoughTasks', 'Se ha de entrar mínimo una tarea antes de proceder'],
  [
    'NotEnoughEmployees',
    'Se ha de entrar mínimo un empleado antes de planificar',
  ],
  ['EmployeesWithoutName', 'No pueden haber empleados sin nombre'],
  [
    'EmployeesWithDuplicatedNames',
    'No pueden haber empleados con el mismo nombre',
  ],
  ['SkillsWithoutLabel', 'No pueden haber habilidades sin etiqueta'],
  [
    'SkillsWithDuplicatedLabels',
    'No pueden haber habilidades con la misma etiqueta',
  ],
  ['EmailNotFound', 'Error por acceso incorrecto o fallo de contraseña'],
  ['UserNotActive', 'La cuenta no está activada'],
  ['ActivationTokenNotValid', 'El token de activación no es válido'],
  ['AuthenticationTokenNotValid', 'El token de autentificación no es válido'],
  ['InsertNewUser', 'Error al insertar un nuevo usuario'],
  ['InsertPlanificationError', 'Error al insertar una planificación'],
  [
    'PlanificationNotFound',
    'No hemos encontrado esta planificación o bien no estás autorizado para verla',
  ],
  ['InternalServerError', 'Error interno del servidor'],
  [
    'SolverError',
    'El procesado de tu planificación ha fallado. Vuelve a intentarlo en unos instantes.',
  ],
  [
    'SolverNotRespond',
    'Ahora mismo no se puede procesar tu planificación. Vuelve a intentarlo en unos instantes.',
  ],
  [
    'TokenExpired',
    'Por motivos de seguridad la petición no se ha llevado a cabo. En caso de tener usuario vuelve a conectarte. Alternativamente vuelve a intentarlo',
  ],
  [
    'TooManyRequests',
    'Has excedido el número de peticiones permitidas. Espera una hora y vuelve a intentarlo',
  ],
  [
    'TooManyAuthRequests',
    'Has excedido el número de peticiones permitidas. Espera cinco minutos y vuelve a intentarlo',
  ],
])

export const errorNameToMessage = (errorName: string): string => {
  const message = errorMessages.get(errorName)
  if (message) return message
  return 'Error desconocido'
}
